import { apiService } from '@/shared/services/apiServices';

export interface FacilityUserListItem {
  id: string;
  user_id: string | null;
  name: string;
  email: string;
  phone_number?: string | null;
  countryCode?: string | null;
  gender?: string | null;
  academic_title?: string | null;
  status: 'active' | 'inactive';
  facility_id: string;
}

export interface FacilityUserPaginationMeta {
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface ListFacilityUserData {
  data: FacilityUserListItem[];
  pagination: FacilityUserPaginationMeta;
}

export interface ListFacilityUserParams {
  facilityId: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: 'active' | 'inactive';
  isValid?: boolean;
  sortBy?: 'name' | 'status' | 'created_at';
  sortOrder?: 'asc' | 'desc';
}

export interface ListFacilityUserResult {
  success: boolean;
  data?: ListFacilityUserData;
  error?: string;
  accessDenied?: boolean;
}

export const listFacilityUsers = async (
  params: ListFacilityUserParams
): Promise<ListFacilityUserResult> => {
  try {
    const {
      facilityId,
      page = 1,
      limit = 10,
      search,
      status,
      isValid,
      sortBy,
      sortOrder,
    } = params;

    const query = new URLSearchParams({
      facilityId,
      page: String(page),
      limit: String(limit),
    });

    if (search) {
      query.set('search', search);
    }
    if (status) {
      query.set('status', status);
    }
    if (isValid !== undefined) {
      query.set('isValid', String(isValid));
    }
    if (sortBy) {
      query.set('sortBy', sortBy);
    }
    if (sortOrder) {
      query.set('sortOrder', sortOrder);
    }

    const endpoint = `loopay-employee-management/employees?${query.toString()}`;

    const result = await apiService.getAPI(endpoint);

    if (result.error) {
      if (result.status === 403) {
        return { success: false, accessDenied: true };
      }
      return {
        success: false,
        error: 'Nie udało się załadować listy pracowników.',
      };
    }

    return { success: true, data: result.data as ListFacilityUserData };
  } catch {
    return { success: false, error: 'Wystąpił nieoczekiwany błąd.' };
  }
};
